module.exports = __webpack_public_path__ + "static/media/DraftIcon.fc1afe5a.svg";